// extracted by mini-css-extract-plugin
module.exports = {"active":"StepByStep_active__k_lNs","cardActive":"StepByStep_cardActive__oVvqR","cardInactive":"StepByStep_cardInactive__JnaUm","progress-bar":"StepByStep_progress-bar__oBvyP"};